<template>
  <v-dialog
    :value="value"
    width="500"
    transition="fade-transition"
    class="AddProfileDialog add-profile-dialog"
    @input="$emit('input', $event)"
  >
    <v-card class="add-profile-dialog__card">
      <v-row no-gutters>
        <v-col cols="6" class="pa-2">
          <v-card-title>Add child</v-card-title>
          <v-card-text>
            Login with existing child profile or create new one
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="flex-grow-1"
              @click="logInChild"
            >
              <v-icon left>login</v-icon>
              Log in
            </v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-btn
              block
              dark
              color="blue"
              class="text-decoration-none"
              :to="{ name: 'newgame' }"
            >
              <v-icon left>add</v-icon>
              <span class="d-sm-none">Create</span>
              <span class="d-none d-sm-inline">Create new</span>
            </v-btn>
          </v-card-actions>
        </v-col>

        <v-divider vertical inset />

        <v-col cols="6" class="d-flex flex-column pa-2">
          <v-card-title>Add parent</v-card-title>
          <v-card-text>
            Add parent account and load connected child profiles
          </v-card-text>
          <v-card-actions class="add-profile-dialog__card-actions _connect">
            <v-btn
              :disabled="!!parentAccount"
              block
              @click="connectParentAccount"
            >
              <v-icon left>supervisor_account</v-icon>
              {{ parentAccount ? 'Connected' : 'Connect' }}
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-card>

    <LogInNavigationDrawer v-model="showChildLoginDrawer" />
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AddProfileDialog',
  components: {
    LogInNavigationDrawer: () => import('@/components/drawers/login/LogInNavigationDrawer'),
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showChildLoginDrawer: false,
      showParentLoginDialog: false,
    };
  },
  computed: {
    ...mapGetters('parent', [
      'parentAccount',
    ]),
  },
  methods: {
    ...mapActions([
      'setLogInModalState',
    ]),

    logInChild() {
      this.showChildLoginDrawer = !this.showChildLoginDrawer;
    },
    connectParentAccount() {
      this.showChildLoginDrawer = false;
      this.setLogInModalState(true);
    },
  },
};
</script>

<style lang="scss" scoped>
  .add-profile-dialog {
    &__card-actions._connect {
      margin-top: auto;
      margin-bottom: 26px;
    }
  }
</style>
